module.exports = __webpack_public_path__ + "img/chevron-selector-horizontal.fce4b00d.svg";